import type { TFunction } from 'i18next';

/**
 * CompanyInfo.CompanyType codes. '01' is the platform owner (super admin
 * company); '02'-'04' are client tiers.
 */
export const COMPANY_TYPE_CODES = ['01', '02', '03', '04'] as const;

export const getCompanyTypeLabel = (t: TFunction, type?: string | null): string => {
  switch (type) {
    case '01':
      return t('companies.superAdmin', 'Super Admin');
    case '02':
      return t('companies.largeClient', 'Large Client');
    case '03':
      return t('companies.mediumClient', 'Medium Client');
    case '04':
      return t('companies.smallClient', 'Small Client');
    default:
      return type || t('common.unknown', 'Unknown');
  }
};

export const getCompanyTypeColor = (
  type?: string | null,
): 'warning' | 'primary' | 'secondary' | 'info' | 'default' => {
  switch (type) {
    case '01':
      return 'warning';
    case '02':
      return 'primary';
    case '03':
      return 'secondary';
    case '04':
      return 'info';
    default:
      return 'default';
  }
};
